import api from 'services/api';
import Swal from 'sweetalert2';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default async function mensagemAtingirMeta(
  mensagemInicial: string,
  propostaVersaoId: number,
) {
  const retorno = await api.post(
    `/proposta/versao/${propostaVersaoId}/desconto-atingir-meta`,
  );

  if (retorno.data) {
    await Swal.fire({
      title: `Atenção`,
      html: `${mensagemInicial}. A proposta estava com o valor de atingir meta e não é mais válido,
            o mesmo desconto será aplicado a todos equipamentos
            e será necessário atingir meta novamente.`,
      icon: 'warning',
      confirmButtonText: `Ok`,
      showCancelButton: false,
    });
  }
}
